import { useEffect, useRef, useState } from 'react'

import { Tooltip } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'

interface ClampTooltipProps {
  text: string;
  className?: string;
  selected?: boolean;
}

export function ClampTooltip({
  text,
  className = '',
  selected = false,
}: ClampTooltipProps) {
  const textRef = useRef<HTMLDivElement | null>(null)
  const [isClamped, setIsClamped] = useState(false)

  useEffect(() => {
    const element = textRef.current
    if (!element) { return }
    const checkClamped = () => {
      setIsClamped(element.scrollHeight > element.clientHeight)
    }
    checkClamped()
    const resizeObserver = new window.ResizeObserver(checkClamped)
    resizeObserver.observe(element)
    return () => {
      resizeObserver.disconnect()
    }
  }, [text])

  const wrapLongWords = (input: string) => 
    input?.split(/(\s+)/).map(word =>
      word.length > 20 ? word.replace(/(.{20})/g, '$1\u200B') : word
    ).join('')

  const displayText = wrapLongWords(text)

  return (
    <Tooltip
      placement="bottom"
      content={<span className="font-normal">{displayText}</span>}
      defaultComp={
        <div
          ref={textRef}
          className={clsx(
            'overflow-hidden line-clamp-2 break-words',
            selected && 'text-(--sp-color-link) font-semibold',
            className
          )}
        >
          {displayText}
        </div>
      }
      trigger="hover"
      disabled={!isClamped}
      wrapperClassName="!opacity-100"
      className="sp-tooltip max-w-[320px] break-words whitespace-pre-line ml-2"
      portalSelector="body"
    />
  )
}